// src/tableTypes.ts
var getItemParams = (item) => item.params;

export {
  getItemParams
};
